const TIME_INTERVAL_KIND = Object.freeze({
  monthToDate: 'monthToDate',
  weekToDate: 'weekToDate',

  monthThis: 'monthThis',
  monthLast: 'monthLast',
  monthNext: 'monthNext',

  weekLast: 'weekLast',
  weekThis: 'weekThis',
  weekNext: 'weekNext',

  dayToday: 'dayToday',
  dayYester: 'dayYester',
  dayMorrow: 'dayMorrow',

  custom: 'custom',
});

export default TIME_INTERVAL_KIND;
